// extracted by mini-css-extract-plugin
module.exports = {"vGray2":"#f4f5f7","content":"PostContent_content__iDJE1","slider":"PostContent_slider__14DnL","slide":"PostContent_slide__1NzaU"};